export default __webpack_public_path__ + "static/media/640_dummy2016-restaurant04-mobile-de.525392f7.png";